import pagamentobeneficiosRoutes from './beneficios/pagamentoBeneficios/rotas.js';
import cadastroFuncionariosAptosRoutes from './beneficios/administracao/cadastroFuncionariosAptos/rotas.js';
import cadastroRegrasRoutes from './beneficios/administracao/Regras/rotas.js';
import transladoRoutes from './translado/solicitacoes/rotas.js';
import hospedagemRoutes from './hospedagem/rotas.js';
import motRoutes from './mao-de-obra-temporaria/rotas.js';
import tramitacoesJuridicasRoutes from './tramitacoes-juridicas/rotas.js';
import legacyRedirects from './redirects-rotas.js';

const solicitacoesRoute = {
    path: 'solicitacoes',
    name: 'Solicitacoes',
    component: () => import('./SolicitacoesView.vue'),
    children: [
        ...pagamentobeneficiosRoutes,
        ...cadastroFuncionariosAptosRoutes,
        ...cadastroRegrasRoutes,
        ...transladoRoutes,
        ...hospedagemRoutes,
        ...motRoutes,
        ...tramitacoesJuridicasRoutes,
    ],
    meta: {
        rules: ['', 'HOSPEDAGEM-00', 'TRAMITACOES-JURIDICAS-00', 'TEMPORARIO-00'],
    },
};

export default [solicitacoesRoute, ...legacyRedirects];
